import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the ServiceGvariableProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ServiceGvariableProvider {

  constructor(public http: HttpClient) {
    console.log('Hello ServiceGvariableProvider Provider');
  }
  public URL = "http://www.rhtyre.com";
  //public URL = "http://test.rhtyre.com";
}


// WEBPACK FOOTER //
// ./src/providers/service-gvariable/service-gvariable.ts